module.exports = __webpack_public_path__ + "img/logo_vertical.04ea7df9.png";